export default __webpack_public_path__ + "static/media/support_icon.b6872458.png";